module.exports = __webpack_public_path__ + "static/img/FigmaDDSSlicePNG0cbf549e94b2ce81c5de6cfdbd3b2fd1.0cbf549e.png";